import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';

@Component({
    selector: 'fi-task-v2-completed-by-short',
    templateUrl: './fi-task-v2-completed-by-short.component.html',
    styleUrls: ['./fi-task-v2-completed-by-short.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-completed-by-short' },
    standalone: false,
})
export class FiTaskV2CompletedByShortComponent {
    @Input({ required: true }) taskCreatedOn: string;
    @Input({ required: true }) taskCompletedOn: string;
    @Input({ required: true }) taskCompletedByProfile: IUserProfile;

    protected readonly FiProfileSizes = FiProfileSizes;

    constructor(
        private sharedActionsService: SharedActionsBaseService,
        private fiTaskV2HelperService: FiTaskV2HelperService,
    ) {}

    protected openUserDetails($event: MouseEvent): void {
        $event.stopPropagation();
        this.sharedActionsService.openUserViewPopup(this.taskCompletedByProfile.Id);
    }

    protected getCreatedLabel() {
        return this.fiTaskV2HelperService.getCreatedLabel(this.taskCreatedOn);
    }

    protected getCompletedLabel() {
        return this.fiTaskV2HelperService.getCompletedLabel(this.taskCompletedOn);
    }
}
